import React from 'react';
import { SectionStyles } from "./section.styles";
import Box from "@material-ui/core/Box";
import { useTheme } from "@material-ui/core/styles";

export const Section = ({ color, padding, children, backgroundImage, images }: Props) => {
    const classes = SectionStyles();
    const theme = useTheme();

    if (!padding)
        padding = 0;


    const asset = backgroundImage && images ? images.filter(x => x.assetId === backgroundImage)[0] : null;

    const getBackground = () => {
        if (color === "darkest")
            return theme.palette.primary.darkest;
        else if (color === "dark")
            return theme.palette.primary.dark;
        else if (color === "main")
            return theme.palette.primary.main;
        else if (color === "light")
            return theme.palette.primary.light;
        else if (color === "lightest")
            return theme.palette.primary.lightest;
        else
            return theme.palette.background.paper
    }

    return (
        <Box className={classes.sectionContainer} style={{ backgroundColor: getBackground(), color: theme.palette.getContrastText(getBackground()), padding: theme.spacing(padding), backgroundImage: asset ? `url(${asset.localFile.publicURL})` : "", backgroundSize: "cover" }}>
            {children}
        </Box>

    );
}

interface Props {
    color?: string;
    padding?: number;
    children: any;
    backgroundImage?: string;
    images: Array<any>;
}

Section.NAME = "Section";
export default Section;

